import React, {Component} from 'react';
import NumberFormat from 'react-number-format';
import { toast } from 'react-toastify';
import moment from "moment/moment";


export default class RevenueGoal extends Component {
    state = {
        isCalculationButtonClicked: false,
        disableSaveButton: true
    }

    handleChanges = (field, values) => {
        const {floatValue} = values;
        this.props.handleRevenueGoalChanges(field, floatValue);

        this.setState({disableSaveButton: false});
    };

    clickedCalculationButton = () => {
        if(this.props.overridePlProfile.override_calculate_goal) {
            toast.error("Calculated goal is overridden. Please go to `Override Goals` to edit goals.")
        } else {
            this.setState({
                isCalculationButtonClicked: true
            });
        }
    };

    saveRevenueGoal = () => {
        if(!this.state.disableSaveButton) {
            this.props.saveRevenueGoal();
            this.setState({
                disableSaveButton: true,
                isCalculationButtonClicked: false
            });
        }
    };

    cancelChanges = () => {
        this.setState({
            disableSaveButton: true,
            isCalculationButtonClicked: false
        });

        this.props.cancelRevenueGoalChanges();
    } ;

    render = () => {
        const {revenueGoal, plProfile} = this.props;
        const {isCalculationButtonClicked} = this.state;
        const today = moment().subtract(1, "month");
        const profileEndDate = plProfile && plProfile.end_date ? moment(plProfile.end_date): today;
        const isOldProfile = profileEndDate < today;

        return (
            <section className="container-fluid p-0">
                <div className="clearfix"></div>
                <div className={`card ${this.props.iw ? 'card-section' : 'border'}`}>
                    <div className={`card-header py-2 ${this.props.iw ? 'text-white' : 'bg-light'}`}>
                        <ul className="secondary-menu float-left">
                            <li className="pl-0" onClick={this.props.backToDashboard}>
                            <a className="pl-0"> Back</a></li>
                        </ul>
                        <div className="text-center"><h5 className="mb-1">Calculated Revenue Goals</h5></div>
                    </div>
                    <div className="card-body bg-f5">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="mb-0">Total Revenue Goal</label>
                                    <NumberFormat type="tel" 
                                        value={revenueGoal.total_revenue_goal}  
                                        thousandSeparator={true} prefix={'$ '} 
                                        allowNegative={false} 
                                        className="form-control text-center" 
                                        name="total_revenue_goal" disabled 
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="mb-0">Monthly Goal</label>
                                    <NumberFormat type="tel" value={revenueGoal.monthly_goal}  
                                        thousandSeparator={true} prefix={'$ '} 
                                        allowNegative={false} 
                                        className="form-control text-center" 
                                        name="monthly_goal" disabled 
                                    />
                                </div>
                            </div>
                            <div className={isCalculationButtonClicked ? "d-none" : "col-5 col-sm-2"}>
                                <br/>
                                <button className="btn btn-info"
                                    onClick={this.clickedCalculationButton}
                                >
                                    <i className="fa fa-calculator"></i> Calculate
                                </button>
                            </div>
                        </div>
                        {isCalculationButtonClicked ?
                            <fieldset className="card card-body pt-1">
                                <legend className="mb-0 pb-1" style={{width:"fit-content"}}>
                                    <small><small>Edit Calculated Revenue Goal </small></small>
                                </legend>
                                <div className="row">
                                    <div className="col-sm-3">
                                        <label className="mb-0">Planned New Business</label>
                                        <NumberFormat type="tel" 
                                            value={revenueGoal.new_revenue_goal}  
                                            thousandSeparator={true} prefix={'$ '} 
                                            allowNegative={false} 
                                            onValueChange={(values) => this.handleChanges(
                                                "new_revenue_goal", values
                                            )} 
                                            className="form-control text-center" 
                                            name="new_revenue_goal" 
                                            disabled={isOldProfile}
                                        />
                                    </div>
                                    <div className="col-sm-3">
                                        <label className="mb-0">Planned Renewal Business</label>
                                        <NumberFormat type="tel" 
                                            value={revenueGoal.renewal_revenue_goal} 
                                            thousandSeparator={true} prefix={'$ '} 
                                            allowNegative={false} 
                                            onValueChange={(values) => this.handleChanges(
                                                "renewal_revenue_goal", values
                                            )} 
                                            className="form-control text-center" 
                                            name="renewal_revenue_goal" 
                                            disabled={isOldProfile}
                                        />
                                    </div>
                                    {!isOldProfile && (
                                        this.props.permission.can_add || this.props.permission.can_edit
                                    ) &&
                                        <div className="col-3 col-sm-1">
                                            <br/>
                                            <button className="btn btn-success" 
                                                onClick={this.saveRevenueGoal}
                                            > Save </button>
                                        </div>
                                    }
                                    <div className="col-4 col-sm-1">
                                        <br/>
                                        <button className="btn btn-warning" 
                                            onClick={this.cancelChanges}
                                        > Cancel </button>
                                    </div>
                                </div>
                            </fieldset>
                            :
                            ""
                        }

                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="mb-0">% New Business</label>
                                    <NumberFormat type="tel" 
                                        value={revenueGoal.new_revenue_goal_per}  
                                        thousandSeparator={true} suffix={' %'} 
                                        allowNegative={false} 
                                        className="form-control text-center" 
                                        name="new_revenue_goal_per" disabled 
                                    />
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label className="mb-0">% Renewal Business</label>
                                    <NumberFormat type="tel" 
                                        value={revenueGoal.renewal_revenue_goal_per}  
                                        thousandSeparator={true} suffix={' %'} 
                                        allowNegative={false} 
                                        className="form-control text-center" 
                                        name="renewal_revenue_goal_per" disabled 
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        )
    }
}


// WEBPACK FOOTER //
// ./src/components/agencyRevenue/RevenueGoal.js